import { Link, useLocation } from 'wouter';
import { MessageSquare, Clock, Settings } from 'lucide-react';
import type { ComponentType } from 'react';

interface Tab {
  href: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
}

const TABS: Tab[] = [
  { href: '/', label: 'Chat', icon: MessageSquare },
  { href: '/sessions', label: 'Sessions', icon: Clock },
  { href: '/settings', label: 'Settings', icon: Settings },
];

export function BottomNav() {
  const [location] = useLocation();

  return (
    <nav
      className="sticky bottom-0 z-10 border-t border-fog bg-ivory/95 backdrop-blur"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex items-stretch">
        {TABS.map((tab) => {
          const active = location === tab.href;
          const Icon = tab.icon;
          return (
            <li key={tab.href} className="flex-1">
              <Link
                href={tab.href}
                className={[
                  'flex flex-col items-center justify-center gap-0.5 py-2 transition-colors',
                  active ? 'text-gold' : 'text-bark hover:text-espresso',
                ].join(' ')}
              >
                <Icon className="h-5 w-5" />
                <span className="text-xs font-medium">{tab.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
